import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import hubDaive from './assets/hubdaive.png';
import './Login.css'

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [rememberMe, setRememberMe] = useState(() => {
    return localStorage.getItem('rememberMePreference') === 'true';
  });

  const navigate = useNavigate();

  useEffect(() => {
      const token = localStorage.getItem('token');
      
      if (token) {
          navigate('/home');
      }
  }, [navigate]);

  const validateForm = () => {
    if (!username || !password) {
      setError('Username and password are required');
      return false;
    }
    setError(''); 
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    
    const formDetails = new URLSearchParams();
    formDetails.append('username', username);
    formDetails.append('password', password);
    formDetails.append('remember_me', rememberMe ? 'true' : 'false');

    try {
      const response = await fetch('https://hubdaive.com.br/api/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDetails,
      });

      setLoading(false);

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('rememberMePreference', rememberMe);
        
        localStorage.setItem('token', data.access_token);
        sessionStorage.removeItem('token');
        localStorage.setItem('is_admin', data.is_admin);
        localStorage.setItem('username', data.name);
        
        navigate('/home');
      } else {
        const errorData = await response.json();
        setError(errorData.detail || 'Authentication failed!');
      }
    } catch (error) {
      setLoading(false);
      setError('An error occurred. Please try again later.');
    }
  };

  return (
    <div className="login-wrapper">
      <img src={hubDaive} alt="logo" className="login-logo" />

      <h2 className="login-title">LOGIN</h2>

      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-field">
          <input
            type="text"
            placeholder="EMAIL DAIVE"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="login-input"
          />
        </div>

        <div className="login-field-password">
          <input
            type="password"
            placeholder="SENHA"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input-password"
          />
        </div>

        <button type="submit" disabled={loading} className="login-btn">
          {loading ? '...' : 'ENTRAR'}
        </button>

        <div className="login-remember">
          <input
            type="checkbox"
            id="minha-checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          <label htmlFor="minha-checkbox">Lembrar acesso</label>
        </div>

        {error && <p className="login-error">{error}</p>}

        <div className="login-links">
          <p onClick={() => navigate('/register')}>Criar conta</p>
          <p onClick={() => navigate('/password')}>Esqueci minha senha</p>
        </div>
      </form>
    </div>
  );
}

export default Login;
